import { render, staticRenderFns } from "./TableIncomeProductType.vue?vue&type=template&id=396928ca&lang=pug&"
import script from "./TableIncomeProductType.vue?vue&type=script&lang=ts&"
export * from "./TableIncomeProductType.vue?vue&type=script&lang=ts&"
import style0 from "./TableIncomeProductType.vue?vue&type=style&index=0&id=396928ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports